import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, signal, inject } from '@angular/core';
import { ErrorMessage } from '../model/error-message';
import { ReleaseNote } from '../model/release-note';
import { Feedback } from '../model/feedback';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  private http = inject(HttpClient);


  public readonly errorMessages = signal<ErrorMessage[]>([]);
  public readonly releaseNotes = signal<ReleaseNote[]>([]);
  public showFeedbackDialog = false;

  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };


  constructor() {
    this.loadMessages();
    this.loadReleaseNotes();
  }

  public loadMessages(): void {
    this.http.get<ErrorMessage[]>(environment.errorMessagesUrl).subscribe({
      next: result => this.errorMessages.set(result),
      error: () => this.errorMessages.set([])
    });
  }

  public loadReleaseNotes(): void {
    this.http.get<ReleaseNote[]>(environment.releaseNotesUrl).subscribe({
      next: result => this.releaseNotes.set(result),
      error: () => this.releaseNotes.set([])
    });
  }

  public sendFeedbackMessage(feedback: Feedback): Observable<Feedback> {
    return this.http.post<Feedback>(environment.feedbackUrl, feedback, this.httpOptions);
  }

}
